type Kpi = {
  kpiName: string;
  kpitag: string | string [];
  kpiUnit: string;
  area?: string;
};

type KpiChangeSummary = {
  created: Kpi[];
  deleted: Kpi[];
  updated: { from: Kpi; to: Kpi }[];
  reordered: { kpi: Kpi; fromIndex: number; toIndex: number }[];
};

function groupByArea(data: Kpi[]): Record<string, Kpi[]> {
  const grouped: Record<string, Kpi[]> = {};
  for (const kpi of data) {
    const key = kpi.area || 'default';
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(kpi);
  }
  return grouped;
}

export default function getKpiChangeSummary(
  modifiedData: Kpi[],
  currentData: Kpi[]
): KpiChangeSummary {
  const created: Kpi[] = [];
  const deleted: Kpi[] = [];
  const updated: { from: Kpi; to: Kpi }[] = [];
  const reordered: { kpi: Kpi; fromIndex: number; toIndex: number }[] = [];

  const modifiedGrouped = groupByArea(modifiedData);
  const currentGrouped = groupByArea(currentData);

  const allAreas = new Set([...Object.keys(modifiedGrouped), ...Object.keys(currentGrouped)]);

  for (const area of allAreas) {
    const modifiedKpis = modifiedGrouped[area] || [];
    const currentKpis = currentGrouped[area] || [];

    const modifiedMap = new Map(modifiedKpis.map((kpi) => [kpi.kpitag, kpi]));
    const currentMap = new Map(currentKpis.map((kpi) => [kpi.kpitag, kpi]));

    // Detect created & updated
    for (const modKpi of modifiedKpis) {
      const curKpi = currentMap.get(modKpi.kpitag);
      if (!curKpi) {
        created.push(modKpi);
      } else if (
        modKpi.kpiName !== curKpi.kpiName ||
        modKpi.kpiUnit !== curKpi.kpiUnit ||
        modKpi.area !== curKpi.area
      ) {
        updated.push({ from: curKpi, to: modKpi });
      }
    }

    // Detect deleted
    for (const curKpi of currentKpis) {
      if (!modifiedMap.has(curKpi.kpitag)) {
        deleted.push(curKpi);
      }
    }

    // Detect reordered (only for unchanged KPIs in this area)
    const unchangedTags = currentKpis
      .filter(
        (kpi) =>
          modifiedMap.has(kpi.kpitag) &&
          !updated.find((u) => u.to.kpitag === kpi.kpitag)
      )
      .map((kpi) => kpi.kpitag);

    const currentOrder = unchangedTags;
    const modifiedOrder = modifiedKpis
      .map((kpi) => kpi.kpitag)
      .filter((tag) => unchangedTags.includes(tag));

    currentOrder.forEach((tag, index) => {
      const newIndex = modifiedOrder.indexOf(tag);
      if (newIndex !== index && newIndex !== -1) {
        const kpi = modifiedMap.get(tag)!;
        reordered.push({ kpi, fromIndex: index, toIndex: newIndex });
      }
    });
  }

  return {
    created,
    deleted,
    updated,
    reordered,
  };
}


// type Kpi = {
//     kpiName: string;
//     kpitag: string;
//     kpiUnit: string;
//     area?: string; // New field
//   };
  
//   type KpiChangeSummary = {
//     created: Kpi[];
//     deleted: Kpi[];
//     updated: { from: Kpi; to: Kpi }[];
//     reordered: { kpi: Kpi; fromIndex: number; toIndex: number }[];
//   };
  
//   export default function getKpiChangeSummary(modifiedData: Kpi[], currentData: Kpi[]): KpiChangeSummary {
//     const modifiedMap = new Map(modifiedData.map((kpi, index) => [kpi.kpitag, { ...kpi, index }]));
//     const currentMap = new Map(currentData.map((kpi, index) => [kpi.kpitag, { ...kpi, index }]));
  
//     const created: Kpi[] = [];
//     const deleted: Kpi[] = [];
//     const updated: { from: Kpi; to: Kpi }[] = [];
//     const reordered: { kpi: Kpi; fromIndex: number; toIndex: number }[] = [];
  
//     // Detect created & updated & reordered
//     for (const [kpitag, newKpiWithIndex] of modifiedMap.entries()) {
//       if (!currentMap.has(kpitag)) {
//         created.push(newKpiWithIndex);
//       } else {
//         const currentKpiWithIndex = currentMap.get(kpitag)!;
  
//         if (
//           newKpiWithIndex.kpiName !== currentKpiWithIndex.kpiName ||
//           newKpiWithIndex.kpiUnit !== currentKpiWithIndex.kpiUnit ||
//           newKpiWithIndex.area !== currentKpiWithIndex.area

//         ) {
//           updated.push({ from: currentKpiWithIndex, to: newKpiWithIndex });
//         }
  
//         if (newKpiWithIndex.index !== currentKpiWithIndex.index) {
//           reordered.push({
//             kpi: newKpiWithIndex,
//             fromIndex: currentKpiWithIndex.index,
//             toIndex: newKpiWithIndex.index,
//           });
//         }
//       }
//     }
  
//     // Detect deleted
//     for (const [kpitag, oldKpi] of currentMap.entries()) {
//       if (!modifiedMap.has(kpitag)) {
//         deleted.push(oldKpi);
//       }
//     }
  
//     return {
//       created,
//       deleted,
//       updated,
//       reordered,
//     };
//   }
  